import { useQuery } from '@tanstack/react-query';
import { api } from '../api';
import { UserAPI } from '@shared/types/api';

/**
 * Hook to search cities with availability status.
 *
 * - `selectedCity`: hint to include this city in results; not part of the query key
 *   so changing the selection doesn't refetch.
 * - `limit`: server result cap. Defaults to 8 server-side. The paginated quiz
 *   passes a larger value to render every supported city scrollably.
 * - `activeOnly`: when true, the server only returns cities Outclose is currently
 *   serving (skipping "coming soon" entries). Auto-detection in this mode also
 *   restricts the closest city to active ones.
 */
export function useSearchCities(
  query: string,
  selectedCity?: string,
  limit?: number,
  activeOnly?: boolean,
) {
  return useQuery({
    queryKey: ['cities', query, selectedCity, limit, activeOnly],
    queryFn: async (): Promise<UserAPI.GetCitiesResponse> => {
      const params = new URLSearchParams();
      params.append('query', query);
      if (selectedCity) {
        params.append('selectedCity', selectedCity);
      }
      if (limit) {
        params.append('limit', String(limit));
      }
      if (activeOnly) {
        params.append('activeOnly', 'true');
      }
      return api.get(`/user/cities?${params.toString()}`);
    },
    placeholderData: (previousData) => previousData,
  });
}

